import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 600,
      fontSize: '1.3rem',
      backgroundColor: palette.background.lightblue,
      border: 'none',
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
      gap: '5px',
      boxShadow: palette.shadows.boxInnerShadow,
      borderRadius: '10px',
      padding: '10px 15px',
      cursor: 'pointer',
      color: palette.background.box,
      transition: '0.3s ease',
      transform: 'scale(1)',
      '&:hover': {
        transform: 'scale(1.05)'
      }
    },
    default: {
      opacity: '1'
    },
    finished: {
      opacity: '0.6'
    },
    date: {
      fontWeight: 500,
      fontSize: '1rem'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
